// Module
var code = `<div class="fatal"><div class="message" ng-bind-html="formattedMessage"></div><button ng-click="continue()" name="continue" class="modal-action-button" translate-once="front_royal_api_error_handler.fatal.continue"></button></div>`;
// Exports
export default code;